var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIconGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_781_5216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.98 5.74512H11.49C8.31712 5.74512 5.745 8.31724 5.745 11.4901V22.9801C5.745 26.153 8.31712 28.7251 11.49 28.7251H22.98C26.1529 28.7251 28.725 26.153 28.725 22.9801V11.4901C28.725 8.31724 26.1529 5.74512 22.98 5.74512Z",
    stroke: "#757575",
    strokeWidth: 1.09978,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.235 21.5438C19.6147 21.5438 21.5438 19.6147 21.5438 17.235C21.5438 14.8554 19.6147 12.9263 17.235 12.9263C14.8554 12.9263 12.9263 14.8554 12.9263 17.235C12.9263 19.6147 14.8554 21.5438 17.235 21.5438Z",
    stroke: "#757575",
    strokeWidth: 0.916486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6981 10.7717V10.7726",
    stroke: "#757575",
    strokeWidth: 0.916486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_5216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.47,
    height: 34.47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIconGray);
export default __webpack_public_path__ + "static/media/instagramIconGray.63b9ca79e7119bc7e90e05f1255afd6a.svg";
export { ForwardRef as ReactComponent };